import React from 'react';
import {
    KurbanReportStatusBadge,
} from '../../KurbanReportUIHelpers';

import Moment from 'react-moment';


export function RoleColumnFormatter(cellContent, row) {

    if (!cellContent) {
        return <span className={`label label-lg label-light-danger label-inline text-nowrap`}>
            Belum Diset
        </span>
    }

    return <span className={`label label-lg label-light-primary label-inline`}>
        {cellContent}
    </span>
}

export function StatusColumnFormatter(cellContent, row) {

    if (!KurbanReportStatusBadge[cellContent]) {
        return (

            <span className={`label label-lg text-nowrap label-light-dark label-inline`}>
                {cellContent}
            </span>
        )
    }

    const getLabelCssClasses = () => {
        return `label label-lg text-nowrap label-light-${KurbanReportStatusBadge[cellContent].type
            } label-inline`;
    };

    return (
        <span className={getLabelCssClasses()}>
            {KurbanReportStatusBadge[cellContent].text}
        </span>
    );

}

export function ActiveUntilColumnFormatter(cellContent, row) {

    let now = new Date()
    let entryDate = new Date(cellContent)
    const styleDeterminer = () => {
        if (!cellContent) {
            return 'success'
        } else if (entryDate > now) {
            return 'warning'
        } else if (entryDate < now) {
            return 'danger'
        }
    }


    return (
        <span className={`label label-lg text-nowrap label-light-${styleDeterminer()} label-inline`}>
            {cellContent ? <Moment format="DD-MM-YYYY">{cellContent}</Moment> : "Aktif Selamanya"}
        </span>
    );

}

export const NameColumnFormatter = (cellContent, row) => {
    // console.log(row)
    const names = []
    for (const donation_item of row.donation_item) {
        for (const key in donation_item) {
            // console.log(key)
            if (
                key === "name_1" || key === "name_2" ||
                key === "name_3" || key === "name_4" ||
                key === "name_5" || key === "name_6" ||
                key === "name_7"
            ) {
                names.push(donation_item[key])
            }
        }
    }

    return (
        <>
            <ol style={{
                margin: 0,
                padding: 0
            }}>
                {names.map((item) => {
                    if (item) {
                        return (
                            <li>{item}</li>
                        )
                    }

                })}
            </ol>
        </>
    )
}